export default __webpack_public_path__ + "static/media/logoorange.319592b8.png";